import React from 'react'
import Form from '../AddCompany/Form'
import { Breadcrumb, SimpleCard } from 'app/components'
import { Box, styled } from '@mui/system'

const Container = styled('div')(({ theme }) => ({
    margin: '30px',
    [theme.breakpoints.down('sm')]: {
        margin: '16px',
    },
    '& .breadcrumb': {
        marginBottom: '30px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '16px',
        },
    },
}))

const EditCompany = () => {
    return (
        <Container>
            <div className="breadcrumb">
                <Breadcrumb
                    routeSegments={[
                        { name: 'Comapnies', path: '/admin/company/all' },
                        { name: 'Form' },
                    ]}
                />
            </div>
            <SimpleCard title="Edit Company">
                <Form />
            </SimpleCard>
            <Box py="12px" />
        </Container>
    )
}

export default EditCompany
